import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import styles from './components/Css/Top5Comedy.module.css';
import { useUniqueAudiosByCategory } from "../hooks/useChapters";
import Loading from "../common/HousGlass Loader/Loading";
import { useNavigate } from "react-router-dom";

const TopComedy = () => {
  const { audios, isLoading } = useUniqueAudiosByCategory('Comedy', 'Audio', 'Audio Book', 1, 5);
  const navigate = useNavigate();
  
  if (isLoading) {
    return <div><Loading /></div>
  }
  
  // Sort audios by some criteria and add number property
  const sortedTopAudios = [...audios]
    .map((item, index) => ({
      ...item,
      number: index + 1
    }))
    .slice(0, 5); // Keep only top 5
    
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2>Top 5 in Comedy</h2>
      </div>
      
      <Swiper
        modules={[Navigation, Mousewheel]}
        navigation
        mousewheel={{ forceToAxis: true, invert: false }}
        spaceBetween={20}
        slidesPerView={1}
        breakpoints={{
          320: { slidesPerView: 3, spaceBetween: 10 },
          480: { slidesPerView: 3, spaceBetween: 12 },
          768: { slidesPerView: 4, spaceBetween: 20 },
          1024: { slidesPerView: 6, spaceBetween: 20 },
          1200: { slidesPerView: 7, spaceBetween: 20 },
        }}
        className={styles.swiper}
      >
        {sortedTopAudios.map((item) => {
          return (
            <SwiperSlide key={item.audio_id}>
              <div
                className={styles.comedyItem}
                role="button"
                tabIndex={0}
              >
                <div className={styles.imageContainer}>
                  {/* Use responsive images based on screen size */}
                  <img
                    src={window.innerWidth > 768
                      ? (item.computer_image_url || item.cover_image_url)
                      : (item.mobile_image_url || item.cover_image_url)}
                    alt={item.audio_title}
                    className={styles.image}
                    onClick={() => navigate(`/audio-play/${item.audio_slug}`)}
                  />
                  <div className={styles.numberBadge}>
                    <span>{item.number}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default TopComedy;